<!-- UI-7 C6: Image Group information pop-up (opened from an image-group card), mirroring the
     Image detail pop-up. Wraps the existing ImageGroupDetails (full info + actions) so nothing
     is duplicated; the group name + Open action live in the header. -->
<template>
<b-modal :active="active" has-modal-card scroll="keep" @update:active="v => $emit('update:active', v)">
  <div class="modal-card igm-card" v-if="imageGroup">
    <header class="modal-card-head igm-head">
      <span class="igm-title">{{ imageGroup.name }}</span>
      <button class="delete" :aria-label="$t('button-close')" @click="$emit('update:active', false)"></button>
    </header>
    <section class="modal-card-body igm-body">
      <image-group-details
        :image-group="imageGroup"
        editable
        @delete="onDelete"
        @deleteImage="$emit('deleteImage', $event)"
        @addToImageGroup="$emit('addToImageGroup', $event)"
      />
    </section>
    <footer class="modal-card-foot igm-foot">
      <button class="button" @click="$emit('update:active', false)">{{ $t('button-close') }}</button>
      <open-image-group-button :image-group="imageGroup" :key="`open-ig-modal-${imageGroup.id}`" />
    </footer>
  </div>
</b-modal>
</template>

<script>
import ImageGroupDetails from './ImageGroupDetails';
import OpenImageGroupButton from './OpenImageGroupButton';

export default {
  name: 'image-group-detail-modal',
  components: {ImageGroupDetails, OpenImageGroupButton},
  props: {
    active: {type: Boolean, default: false},
    imageGroup: {type: Object, default: null}
  },
  methods: {
    onDelete() {
      this.$emit('delete');
      this.$emit('update:active', false);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/colors.scss';

.igm-card {
  width: 52rem;
  max-width: 95vw;
}
.igm-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $surface;
  border-bottom: 1px solid $line-1;
}
.igm-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: $ink-1;
}
.igm-body {
  background: $surface;
}
.igm-foot {
  background: $surface;
  border-top: 1px solid $line-1;
  justify-content: flex-end;
  gap: 0.6rem;
}
</style>
